import React from 'react';
import { config } from '@triare/auth-redux';
import InformationContent from '../../../../components/Pages/Auth/SignUp/Information';
import Simple from '../../../../components/Layout/Simple';

const { displayName } = config;

function Information(): React.ReactNode {
  document.title = `${displayName}: Information`;

  return (
    <Simple>
      <InformationContent />
    </Simple>
  );
}

export default Information;
